import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/imunizacao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioDeAplicacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-de-aplicacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsolidadoAplicacao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-consolidado-aplicacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFaltosoAprazamento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-faltoso-aprazamento?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
